import { render, staticRenderFns } from "./Duel_Section_Voting.vue?vue&type=template&id=e2a6224a&"
import script from "./Duel_Section_Voting.vue?vue&type=script&lang=js&"
export * from "./Duel_Section_Voting.vue?vue&type=script&lang=js&"
import style0 from "./Duel_Section_Voting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports